<template>
    <Layout>
        <main :class="$style.page">
            <template v-if="isUserInfoLoaded">
                <section
                    v-if="isAuthorized && user"
                    :class="$style.auth_title_page"
                >
                    <Typography
                        is="h1"
                        type="header"
                        size="l"
                    >
                        {{ $tr('rewards.title') }}
                    </Typography>
                </section>
                <section
                    v-else
                    :class="$style.non_auth_title_page"
                >
                    <Typography
                        is="h2"
                        type="header"
                        size="l"
                    >
                        {{ $tr('shop.page_title_non_auth') }}
                    </Typography>
                    <Typography
                        size="m"
                        :class="$style.non_auth_description"
                    >
                        {{ $tr('shop.page_description') }}
                    </Typography>
                    <GoogleAuth :onFinish="authCallback" />
                </section>
            </template>
            <RewardsCards
                :rewards="rewardsStore.rewards"
                :purchaseReward="rewardsStore.purchaseReward"
            />
            <PromoSignInVertical :class="$style.promo_mobile" />
            <section>
                <Typography
                    is="h2"
                    type="header"
                    size="xs"
                    :class="$style.section_title"
                >
                    {{ $tr('rewards.coming_soon') }}
                </Typography>
                <ShopCards />
            </section>
        </main>
    </Layout>
</template>
<script lang="ts" setup>
import Layout from '@/layouts/ModernTwoColumnsLayout.vue'
import { onMounted, onServerPrefetch, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useCategoriesStore } from '@/store/categories-store'
import Typography from '@/components_new/Typography.vue'
import ShopCards from '@/components_new/ShopCards/ShopCards.vue'
import { useUserStore } from '@/store/user-store/user-store'
import { useRewardsStore } from '@/store/rewards-store'
import { storeToRefs } from 'pinia'
import PromoSignInVertical from '@/components_new/PromoItems/components/PromoSignInVertical.vue'
import GoogleAuth from '@/components_new/GoogleAuth.vue'
import RewardsCards from '@/components_new/RewardsCards/RewardsCards.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { useI18nAddon } from '@/i18n/i18n'

const categoriesStore = useCategoriesStore()

const userStore = useUserStore()
const { isAuthorized, user, isUserInfoLoaded } = storeToRefs(userStore)

const rewardsStore = useRewardsStore()
const router = useRouter()

const authCallback = async () => {
    const userData = await userStore.getUser()

    if (userData) {
        router.push({ name: ROUTE_NAMES.PROFILE })
    }
}

onServerPrefetch(async () => {
    await Promise.all([categoriesStore.setMainData(), rewardsStore.getRewards()])
})

onMounted(async () => {
    await Promise.all([categoriesStore.setMainData(), rewardsStore.getRewards()])
})

const { currentLocale } = useI18nAddon()
watch(currentLocale, categoriesStore.setMainData)
</script>
<style module>
.page {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.section_title {
    margin-bottom: 16px;
}

.auth_title_page {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 72rem;
}

.non_auth_title_page {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.non_auth_description {
    max-width: 665px;
    margin: 16px 0 24px;
}

.drop_cards {
    margin: 16px 0;
}

.promo_mobile {
    display: block;
}

.promo_tablet {
    display: none;
}

@media (--tablet-plus) {
    .promo_mobile {
        display: none;
    }

    .promo_tablet {
        display: block;
    }
}

@media (--desktop-small-plus) {
    .promo_tablet {
        display: none;
    }
}
</style>
